/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  getUserSubscription,
  cancelSubscription,
} from "../../store/subscription-action";
import { formatDateToCustomString } from "../../utils/utils";
import LoadingOverlay from "../Ui/LoadingOverlay";
import ConfirmPopup from "../Ui/ConfirmCancelSub";

const UserSubscription = () => {
  const [subs, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState();
  const [openPopup, setOpen] = useState(false);
  const [selectSubscription, setSelectedSub] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const dataSubs = await getUserSubscription();
      setTimeout(() => {
        setData(dataSubs.data);
        setLoading(false);
      });
    };
    fetchData();
  }, [refresh]);

  const cancelSubs = async () => {
    if (!selectSubscription) return;

    setLoading(true);
    try {
      const { paypalSubscriptionId } = selectSubscription;
      await cancelSubscription(paypalSubscriptionId);
      setRefresh(Date.now());
      toast.success("Successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const dataSection = useMemo(() => {
    return (
      <table className="w-full text-sm text-left rtl:text-right text-gray-500">
        <caption className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white">
          Subscription
          <p className="mt-1 text-sm font-normal text-gray-500 "></p>
        </caption>
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
          <tr>
            <th scope="col" className="px-4 py-3">
              ID
            </th>
            <th scope="col" className="px-4 py-3">
              Package
            </th>
            <th scope="col" className="px-4 py-3">
              Start
            </th>
            <th scope="col" className="px-4 py-3">
              Next Billing Time
            </th>
            <th scope="col" className="px-4 py-3">
              Status
            </th>
            <th scope="col" className="px-4 py-3">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {!loading ? (
            subs?.map((item, index) => (
              <tr key={index} className="bg-white border-b last:border-none">
                <th scope="row" className="px-4 py-4 whitespace-nowrap ">
                  {item.paypalSubscriptionId}
                </th>
                <td className="px-4 py-4 font-medium text-gray-900 ">
                  {item.plan?.name}
                </td>
                <td className="px-4 py-4">
                  {formatDateToCustomString(item.startTime)}
                </td>
                <td className="px-4 py-4">
                  {formatDateToCustomString(item.nextBillingTime)}
                </td>
                <td className="px-4 py-4">
                  <span className="inline-flex items-center bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                    {item.status}
                  </span>
                </td>
                <td>
                  {item.status === "ACTIVE" && (
                    <button
                      disabled={loading}
                      onClick={() => {
                        setSelectedSub(item);
                        setOpen(true);
                      }}
                      className="text-white bg-slate-700 hover:bg-slate-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-1.5 text-center"
                    >
                      Cancel Subscription
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <LoadingOverlay />
          )}
        </tbody>
      </table>
    );
  }, [subs, loading]);

  return (
    <div className="relative">
      {dataSection}
      <ConfirmPopup
        isOpen={openPopup}
        nextBillingTime={selectSubscription?.nextBillingTime}
        handleClick={(e) => {
          cancelSubs();
        }}
        togglePopup={() => {
          setOpen(false);
        }}
      />
    </div>
  );
};

export default UserSubscription;
